import React from 'react';
import './style.scss'; 

const PageNotFound = () => {
    return (
        <div className="containerr">
            <div className="container-star">
                {[...Array(30)].map((_, i) => (
                    <div key={i} className="star-1"></div>
                ))}
                {[...Array(30)].map((_, i) => (
                    <div key={i + 30} className="star-2"></div>
                ))}
                </div>
                <div className="container-bird">
                {[...Array(6)].map((_, i) => (
                    <div key={i} className="bird bird-anim">
                    <div className="bird-container">
                        <div className="wing wing-left">
                        <div className="wing-left-top"></div>
                        </div>
                        <div className="wing wing-right">
                        <div className="wing-right-top"></div>
                        </div>
                    </div>
                    </div>
                ))}
                </div>
                <div className="container-title">
                <div className="titlee">
                    <span className="numberr">4</span>
                    <div className="moon">
                    <div className="face">
                        <div className="mouth"></div>
                        <div className="eyes">
                        <div className="eye-left"></div>
                        <div className="eye-right"></div>
                        </div>
                    </div>
                    </div>
                    <span className="number">4</span>
                </div>
                <div className="subtitle">Trang này không tồn tại.</div>
                <button className='button-welcomeBack' onClick={() => window.history.back()}>Trở về</button>
            </div>
        </div>
    );
};

export default PageNotFound;